import React from 'react';
import { base } from './AirtableConfig';

export const useAirtableExtras = () => {
    const [data, setData] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                base('extras')
                    .select({ view: "Grid view" })
                    .eachPage((records: any, fetchNextPage) => {
                        setData(records);
                        fetchNextPage();
                    });
            } catch (err) {
                console.log('error', err);
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    return [data, isLoading] as const;
};
